
import {isEmpty} from "../tools/utils";
const validData = {
    validate: {
        type: '报价单ID', msg: '测试校验提示信息'
    }, response: {}
}
function getFirstPage(){
    let menus = localStorage.getItem('USER_MENUS') ? JSON.parse(localStorage.getItem('USER_MENUS')) : [];
    let page = {};
    if(!isEmpty(menus)){
        page = menus[0][0]['children'][0];
        page.path = page.to;
    }
    return page
}

const base_tabs = [
    getFirstPage()
    // { icon: 'fas fa-home', name: 'home', path: '/', title: '主页' }
]
const stickyTab = {
    tabs: sessionStorage.getItem('emis-page-sticky-tabs') ? JSON.parse(sessionStorage.getItem('emis-page-sticky-tabs')) : base_tabs,
}
const PAGES = {
    purchaseRequisition:{ icon: 'fas fa-boxes', title: '采购申请', group: '', name: 'purchaseRequisition', to: '/pam/purchase-requisition' },

    specialOffer:{ icon: 'fas fa-boxes', title: '特价单', group: '', name: 'specialOffer', to: '/pam/special-offer' },
    specialOfferDetails:{ icon: 'fas fa-boxes', title: '特价单详情', group: '', name: 'specialOfferDetails', to: '/pam/special-offer-details' },
    eorderDetails:{ icon: 'fas fa-boxes', title: 'SC电子订单', group: '', name: 'eorderDetails', to: '/pam/eorder-details/:id' },
    purchaseOrder:{ icon: 'fas fa-boxes', title: '采购订单', group: '', name: 'purchaseOrder', to: '/pam/purchase-order' },
}
const PAGE_BLOCKS = {
    pam:[
        {
            icon: 'fas fa-tasks', title: '采购助手', caption: '', group: '/pam/', name: 'pam', to: '', children: [
                PAGES.purchaseRequisition,PAGES.specialOffer,PAGES.purchaseOrder
            ]
        },
    ],
}
const pagesArr = Object.values(PAGES);
const menuData = {
    // 注释1
    left_menu: {
        status: true,
        menus: localStorage.getItem('USER_MENUS') ? JSON.parse(localStorage.getItem('USER_MENUS')) : [],
    },
    // 详情抽屉状态
    right_view: {
        status: false,
        page: null//哪个页面的详情
    }
}
const rightDrawer = {
    rightDrawerSource: {
        has: false,
        status: true,
        handle: 0,
        list: [{ "title": "邮箱配置" }, { "title": "E2E接口参数" }, { "title": "客户端任务" }]
    }
}

const state = () => ({
    page: Object.assign({}, validData, menuData, stickyTab, rightDrawer)
})

const getters = {
    getValidate: state => state.page.validate,
    getResponse: state => state.page.response,
    getBaseMenu: state => state.page.left_menu,
    getDetailView: state => state.page.right_view,
    getStickyTabs: state => state.page.tabs,
    getRightDrawerHas: state => state.page.rightDrawerSource.has,
    getRightDrawerStatus: state => state.page.rightDrawerSource.status,
    getRightDrawerSource: state => state.page.rightDrawerSource,
}

const mutations = {
    ['setRootMenus'](state, data){
        let menus = [];
        // let userBase = JSON.parse(localStorage.getItem('userBase'));
        // data.forEach(item=>{
        //     let showPages = [];
        //     item.children.forEach(page=>{
        //         if(page.status){
        //             showPages.push(page.name);
        //         }
        //     });
        //     if(item.status && showPages.length > 0){
        //         let block = JSON.parse(JSON.stringify(PAGE_BLOCKS[item.name]));
        //         block[0].children = block[0].children.filter(item=>{
        //             return showPages.includes(item.name)
        //         })
        //         menus.push(block)
        //     }
        // });
        menus = [
            PAGE_BLOCKS.pam,
        ]
        localStorage.setItem('USER_MENUS',JSON.stringify(menus));
        state.page.left_menu.menus = menus;
    },
    ['set-right-drawer-has'](state, data) {
        state.page.rightDrawerSource.has = data
    },
    ['set-right-drawer-status'](state, data) {
        state.page.rightDrawerSource.status = data
    },
    ['set-right-drawer-handle'](state, data) {
        state.page.rightDrawerSource.handle = data
    },
    ['change-left-menu-status'](state) {
        state.page.left_menu.status = !state.page.left_menu.status
    },
    ['response-set'](state, data) {
        state.page.response = data
    },
    ['set'](state, data) {
        let params = {
            type:Object.keys(data)[0],msg:data[Object.keys(data)[0]]
        }
        state.page.validate = params;
    },
    ['clean'](state) {
        state.page.validate = {}
    },
    ['add_tab'](state, data) {
        let tabs = state.page.tabs
        let obj = tabs.filter(it => {
            return it.to == data.to
        });
        if (obj.length < 1) {
            tabs.push(data)
            sessionStorage.setItem('emis-page-sticky-tabs', JSON.stringify(tabs))
        }
    },
    ['delete_tab'](state, data) {
        let obj = state.page.tabs.filter(it => {
            return it.path != data.path
        })
        state.page.tabs = obj;
        sessionStorage.setItem('emis-page-sticky-tabs', JSON.stringify(obj))
    },
    ['clear_tab'](state, data) {
        state.page.tabs = [];
        sessionStorage.setItem('emis-page-sticky-tabs', JSON.stringify([]));
    },
}

function matchPage(name) {
    for (let i = 0; i < pagesArr.length; i++) {
        if (pagesArr[i].name === name) {
            return pagesArr[i]
        }
    }
    return null
}

const actions = {
    async ['response-error-msg']({ commit }, payload) {
        commit('response-set', {
            data: payload.message, status: 'negative', status_code: payload.status,
            status_text: payload.message, error_type: payload.error_type, title: '错误'
        })
    },




    async ['response-success']({ commit }, payload) {
        commit('response-set', { data: payload.data, status: 'positive', status_code: payload.status, status_text: payload.statusText, success_type: payload.success_type, title: payload.success_name })
    },
    async ['response-error']({ commit }, payload) {

        commit('response-set', {
            data: payload.data, status: 'negative', status_code: payload.status,
            status_text: payload.statusText, error_type: payload.error_type, title: payload.error_name
        })
    },
    async ['response-warning']({ commit }, payload) {
        commit('response-set', { data: payload.data, status: 'warning', status_code: payload.status, status_text: payload.statusText, warning_type: payload.warning_type, title: payload.warning_name })
    },
    // form表单校验
    async ['success']({ commit }, payload) {
        commit('set', { msg: payload.data, type: payload.type, status: 'positive' })
    },
    async ['warning']({ commit }, payload) {
        commit('set', { msg: payload.data, type: payload.type, status: 'warning' })
    },
    async ['error']({ commit }, payload) {
        commit('set', { msg: payload.data, type: payload.type, status: 'negative' })
    },
    async ['clean']({ commit }) {
        commit('clean')
    },
    ['add_sticky_tab']({ state, commit }, payload) {
        let ms = state.page.left_menu.menus
        let obj = { icon: 'fas fa-home', name: 'home', path: '/', title: '主页', to: '/' }
        let res = matchPage(payload.name)
        if (res.icon) {
            obj.icon = res.icon
            obj.name = res.name
            obj.path = payload.path
            obj.title = res.title
            obj.to = payload.path
            obj.params = payload.params
            obj.query = payload.query
        }
        if (obj.name != 'main') {
            commit('add_tab', obj)
        }
    },
    ['delete_sticky_tab']({ commit }, payload) {
        commit('delete_tab', payload)
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
